import React from 'react';
import { SectionStyled } from './styled';
import { OVERRIDE_RATES_SECTION_TEST_ID } from '../constants';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export const Section: React.FC<Props> = ({ children, className }) => {
  return (
    <SectionStyled className={className} data-test-id={OVERRIDE_RATES_SECTION_TEST_ID}>
      {children}
    </SectionStyled>
  );
};
